<template>
  <div>
    <div class="mt-3" @dragenter="OnDragEnter" @dragleave="OnDragLeave" @dragover.prevent @drop="onDrop">
      <v-row class="dropzone" column align-center :class="{ 'active-dropzone': active }">
        <v-icon style="font-size: 60px" class="mt-5 mb-3" color="#D0D0D0">mdi-upload</v-icon>

        <span class="d-flex font-weight-medium mb-5" style="font-size: 18px">
          Drag and drop or
          <span class="file-input">
            <label for="file" class="mx-1 font-weight-bold" style="font-size: 18px; text-decoration: underline">
              browse
            </label>
            <input type="file" id="file" class="dropzoneFile" @change="onInputChange" accept="image/*" />
          </span>
          your file
        </span>
      </v-row>

      <v-col class="images-preview pt-3" v-if="error">
        <span class="font-weight-bold" style="color: red" v-html="error" />
      </v-col>
      <v-col class="images-preview pt-3" v-else-if="image">
        <v-col class="headline font-weight-bold mt-3"> Upload Preview </v-col>

        <div class="mt-3" v-html="`File Name: ${(image || {}).name}`" />
        <img style="width: 100%" :src="imageSource" :alt="`Image Preview`" class="pt-3" />
      </v-col>
    </div>
    <v-btn
      round
      flat
      class="my-5 ml-0"
      :style="!submitButtonDisable ? '' : 'background-color: #ffc627; color: black !important'"
      @click="upload"
      :disabled="!submitButtonDisable"
    >
      <span> Submit request </span>
    </v-btn>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import { Logger } from '../mixins/logger';
import { DataLayerMixin } from '../mixins/dataLayerMixin.js';

export default defineComponent({
  emits: ['submitRequestNameChange', 'showUplaodFileConfirmation'],
  name: 'DragAndDropFileZone',
  mixins: [Logger, DataLayerMixin],

  data: () => ({
    isDragging: false,
    dragCount: 0,
    image: null,
    active: false,
    files: [],
    imageSource: null,
    error: null
  }),

  props: {
    detectChanges: Object
  },

  computed: {
    submitButtonDisable() {
      return (this.imageSource || '').length > 0 || Object.keys(this.detectChanges).length > 0;
    }
  },

  methods: {
    toggleImageAttachError(file) {
      if (!((file || {}).type || '').match('image.*')) this.error = 'Please upload an image file';
      else this.error = null;
    },

    toggleActive() {
      this.active = !this.active;
    },

    OnDragEnter(e) {
      e.preventDefault();
      this.toggleActive();

      return false;
    },
    OnDragLeave(e) {
      e.preventDefault();
      this.toggleActive();
    },
    onInputChange(e) {
      this.image = e.target.files[0];
      this.toggleImageAttachError(this.image);
      this.addImage(this.image);
    },
    onDrop(e) {
      e.preventDefault();
      e.stopPropagation();
      this.toggleActive();
      this.image = (((e || {}).dataTransfer || {}).files || [])[0];
      this.toggleImageAttachError(this.image);
      this.addImage(this.image);
    },

    addImage(file) {
      if (!file.type.match('image.*')) {
        this.$toastr.e(`${file.name} is not an image`);
        return;
      }

      this.files.push(file);

      const reader = new FileReader();

      reader.onload = (e) => (this.imageSource = e.target.result);

      reader.readAsDataURL(file);
    },

    upload() {
      this.asuoDataLayerClick('editProfileModal', '6');
      this.logInfo('upload functionality');
      this.$emit('submitRequestNameChange', {
        imageSource: this.imageSource,
        imageName: this.image.name
      });
      this.showUplaodFileConfirmation();
    },
    showUplaodFileConfirmation() {
      this.$emit('showUplaodFileConfirmation');
    }
  }
});
</script>

<style lang="scss" scoped>
.dropzone {
  border: 3px dashed #d0d0d0;
  background-color: #fff;
  transition: 0.3s ease all;
  border-radius: 11px;

  label {
    cursor: pointer;
  }

  input {
    display: none;
  }
}

.active-dropzone {
  color: #fff;
  border: 3px solid #ffc627;
  border-color: #fff;
  background-color: #ffc627;
  border-radius: 11px;

  label {
    color: #fff;
  }

  i {
    color: #fff !important;
  }
}
</style>
